import React, { createContext, useState, useEffect } from "react";
import { BaseUrl, screenPermissionDetails, getCartDetails } from "../Services/Api";

export const UserContext = createContext();


export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authorizedScreen, setAuthorizedScreen] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  // ✅ make fetchUser reusable so it can be called after login
  const fetchUser = async () => {
    try {
      const res = await fetch(`${BaseUrl}/me`, { credentials: "include" });
      if (res.ok) {
        const data = await res.json();
        if (data.user) {
          setUser(data.user);
          setIsLoggedIn(true);

          // fetch screens once
          const screenRes = await screenPermissionDetails();
          setAuthorizedScreen(screenRes.data || []);

          // fetch cart once
          const cartRes = await getCartDetails();
          setCartCount(cartRes.data?.length || 0);
        } else {
          setUser(null);
          setIsLoggedIn(false);
        }
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    } catch (err) {
      console.error("Error fetching user:", err);
    }
  };

  // ✅ fetch user once when app loads
  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        isLoggedIn,
        setIsLoggedIn,
        authorizedScreen,
        cartCount,
        setCartCount,
        refreshUser: fetchUser, // 👈 expose it for Login component
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
